module.exports = __webpack_public_path__ + "img/Casino Roulette.e8a50c2e.jpg";